export default function LearnMoreArrowIcon() {
  return (
    <svg
      className="btn-learn-more__icon"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      aria-hidden
    >
      <path
        d="M5 12h10M12 6l5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
